import { css } from '../styled'
import { TRANSITION_TIME_FAST_MS } from './constants'

export const FAST_TRANSITION = css`
    transition: all ${TRANSITION_TIME_FAST_MS}ms linear;
`
